import { useTranslation } from "@i18n";
export var useFinanceRequirementsData = function useFinanceRequirementsData() {
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var newCarsData = {
    firstTitle: tShort("pre-checkout/new_cars_title1", {
      ns: "web_checkout_finance"
    }),
    secondTitle: tShort("pre-checkout/new_cars_title2", {
      ns: "web_checkout_finance"
    }),
    financeRequirementsDataSaudi: [{
      id: 1,
      key: 'age',
      title: tShort("pre-checkout/new_requirement_1_title", {
        ns: "web_checkout_finance"
      }),
      description: tShort("pre-checkout/new_requirement_1_value", {
        ns: "web_checkout_finance"
      }),
      icon: "material-symbols--person"
    }, {
      id: 2,
      key: 'license',
      title: tShort("pre-checkout/new_requirement_2_title", {
        ns: "web_checkout_finance"
      }),
      description: tShort("pre-checkout/new_requirement_2_value", {
        ns: "web_checkout_finance"
      }),
      icon: "mingcute--certificate-2-fill"
    }, {
      id: 3,
      key: 'violations',
      title: tShort("pre-checkout/new_requirement_3_title", {
        ns: "web_checkout_finance"
      }),
      description: tShort("pre-checkout/new_requirement_3_value", {
        ns: "web_checkout_finance"
      }),
      icon: "mingcute--paper-fill"
    }],
    financeRequirementsDataResident: [{
      id: 1,
      key: 'age',
      title: tShort("pre-checkout/resident_new_requirement_1_title", {
        ns: "web_checkout_finance"
      }),
      description: tShort("pre-checkout/resident_new_requirement_1_value", {
        ns: "web_checkout_finance"
      }),
      icon: "material-symbols--person"
    }, {
      id: 2,
      key: 'license',
      title: tShort("pre-checkout/resident_new_requirement_2_title", {
        ns: "web_checkout_finance"
      }),
      description: tShort("pre-checkout/resident_new_requirement_2_value", {
        ns: "web_checkout_finance"
      }),
      icon: "mingcute--certificate-2-fill"
    }, {
      id: 3,
      key: 'violations',
      title: tShort("pre-checkout/resident_new_requirement_3_title", {
        ns: "web_checkout_finance"
      }),
      description: tShort("pre-checkout/resident_new_requirement_3_value", {
        ns: "web_checkout_finance"
      }),
      icon: "mingcute--paper-fill"
    }],
    additionalDataSaudi: [{
      key: 'item-1',
      title: tShort("pre-checkout/new_additional_1_title", {
        ns: "web_checkout_finance"
      })
    }, {
      key: 'item-2',
      title: tShort("pre-checkout/new_additional_2_title", {
        ns: "web_checkout_finance"
      })
    }, {
      key: 'item-3',
      title: tShort("pre-checkout/new_additional_3_title", {
        ns: "web_checkout_finance"
      })
    }, {
      key: 'item-4',
      title: tShort("pre-checkout/new_additional_4_title", {
        ns: "web_checkout_finance"
      })
    }],
    additionalDataResident: [{
      key: 'item-1',
      title: tShort("pre-checkout/resident_new_additional_1_title", {
        ns: "web_checkout_finance"
      })
    }, {
      key: 'item-2',
      title: tShort("pre-checkout/resident_new_additional_2_title", {
        ns: "web_checkout_finance"
      })
    }, {
      key: 'item-3',
      title: tShort("pre-checkout/resident_new_additional_3_title", {
        ns: "web_checkout_finance"
      })
    }, {
      key: 'item-4',
      title: tShort("pre-checkout/resident_new_additional_4_title", {
        ns: "web_checkout_finance"
      })
    }, {
      key: 'item-5',
      title: tShort("pre-checkout/resident_new_additional_5_title", {
        ns: "web_checkout_finance"
      })
    }]
  };
  var usedCarsData = {
    firstTitle: tShort("pre-checkout/used_cars_title1", {
      ns: "web_checkout_finance"
    }),
    secondTitle: tShort("pre-checkout/used_cars_title2", {
      ns: "web_checkout_finance"
    }),
    financeRequirementsDataSaudi: [{
      id: 1,
      key: 'age',
      title: tShort("pre-checkout/used_requirement_1_title", {
        ns: "web_checkout_finance"
      }),
      description: tShort("pre-checkout/used_requirement_1_value", {
        ns: "web_checkout_finance"
      }),
      icon: "material-symbols--person"
    }, {
      id: 2,
      key: 'license',
      title: tShort("pre-checkout/used_requirement_2_title", {
        ns: "web_checkout_finance"
      }),
      description: tShort("pre-checkout/used_requirement_2_value", {
        ns: "web_checkout_finance"
      }),
      icon: "mingcute--certificate-2-fill"
    }, {
      id: 3,
      key: 'violations',
      title: tShort("pre-checkout/used_requirement_3_title", {
        ns: "web_checkout_finance"
      }),
      description: tShort("pre-checkout/used_requirement_3_value", {
        ns: "web_checkout_finance"
      }),
      icon: "mingcute--paper-fill"
    }],
    additionalDataSaudi: [{
      key: 'item-1',
      title: tShort("pre-checkout/used_additional_1_title", {
        ns: "web_checkout_finance"
      })
    }, {
      key: 'item-2',
      title: tShort("pre-checkout/used_additional_2_title", {
        ns: "web_checkout_finance"
      })
    }, {
      key: 'item-3',
      title: tShort("pre-checkout/used_additional_3_title", {
        ns: "web_checkout_finance"
      })
    }, {
      key: 'item-4',
      title: tShort("pre-checkout/used_additional_4_title", {
        ns: "web_checkout_finance"
      })
    }, {
      key: 'item-5',
      title: tShort("pre-checkout/used_additional_5_title", {
        ns: "web_checkout_finance"
      })
    }]
  };
  var tabs = [{
    key: 'saudi',
    value: tShort("pre-checkout/saudi_tap_title", {
      ns: "web_checkout_finance"
    })
  }, {
    key: 'resident',
    value: tShort("pre-checkout/resident_tap_title", {
      ns: "web_checkout_finance"
    })
  }];
  return {
    newCarsData: newCarsData,
    tabs: tabs,
    usedCarsData: usedCarsData
  };
};